import * as colors from "../constants/colors";
import PropTypes from "prop-types";
import React from "react";
import { css, StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
	button: {
		border: `2px solid ${colors.purple2}`,
		paddingTop: 8,
		paddingBottom: 8,
		paddingLeft: 24,
		paddingRight: 24,
		backgroundColor: colors.purple2,
		borderRadius: 20,
		color: colors.white,
		fontFamily: "priori-sans",
		fontSize: 18,
		fontWeight: "bold",
		textDecoration: "none",
	},
	unfilled: {
		backgroundColor: colors.white,
		color: colors.purple2,
	},
});

function RoundButton({ className, href, onClick, label, type = "filled" }) {
	const styleArgs = [styles.button, type === "unfilled" && styles.unfilled];
	const finalClassName = className ? `${css(...styleArgs)} ${className}` : css(...styleArgs);

	if (href) {
		return (
			<a className={finalClassName} onClick={onClick} href={href}>
				{label}
			</a>
		);
	}

	return (
		<button className={finalClassName} onClick={onClick}>
			{label}
		</button>
	);
}

RoundButton.propTypes = {
	className: PropTypes.string,
	href: PropTypes.string,
	onClick: PropTypes.func,
	label: PropTypes.string.isRequired,
	type: PropTypes.oneOf("filled", "unfilled"),
};

export default RoundButton;



// WEBPACK FOOTER //
// ./src/components/RoundButton.js